__turbopack_context__.v({
  "about-us": "footer-module-scss-module__0M0JVW__about-us",
  "about-us-content": "footer-module-scss-module__0M0JVW__about-us-content",
  "about-us-description": "footer-module-scss-module__0M0JVW__about-us-description",
  "about-us-item": "footer-module-scss-module__0M0JVW__about-us-item",
  "about-us-list": "footer-module-scss-module__0M0JVW__about-us-list",
  "about-us-title": "footer-module-scss-module__0M0JVW__about-us-title",
  "badgs": "footer-module-scss-module__0M0JVW__badgs",
  "button": "footer-module-scss-module__0M0JVW__button",
  "contact": "footer-module-scss-module__0M0JVW__contact",
  "contact-us": "footer-module-scss-module__0M0JVW__contact-us",
  "contact-us-item": "footer-module-scss-module__0M0JVW__contact-us-item",
  "contact-us-item-key": "footer-module-scss-module__0M0JVW__contact-us-item-key",
  "contact-us-item-value": "footer-module-scss-module__0M0JVW__contact-us-item-value",
  "contact-us-title": "footer-module-scss-module__0M0JVW__contact-us-title",
  "copyright": "footer-module-scss-module__0M0JVW__copyright",
  "copyright-item": "footer-module-scss-module__0M0JVW__copyright-item",
  "download-app": "footer-module-scss-module__0M0JVW__download-app",
  "download-app-content": "footer-module-scss-module__0M0JVW__download-app-content",
  "download-app-item": "footer-module-scss-module__0M0JVW__download-app-item",
  "download-app-list": "footer-module-scss-module__0M0JVW__download-app-list",
  "download-app-title": "footer-module-scss-module__0M0JVW__download-app-title",
  "footer": "footer-module-scss-module__0M0JVW__footer",
  "links": "footer-module-scss-module__0M0JVW__links",
  "links-column": "footer-module-scss-module__0M0JVW__links-column",
  "links-column-item-temp-train": "footer-module-scss-module__0M0JVW__links-column-item-temp-train",
  "links-column-list": "footer-module-scss-module__0M0JVW__links-column-list",
  "links-column-title": "footer-module-scss-module__0M0JVW__links-column-title",
  "social-media": "footer-module-scss-module__0M0JVW__social-media",
  "social-media-description": "footer-module-scss-module__0M0JVW__social-media-description",
  "social-media-list": "footer-module-scss-module__0M0JVW__social-media-list",
  "social-media-title": "footer-module-scss-module__0M0JVW__social-media-title",
  "support": "footer-module-scss-module__0M0JVW__support",
  "support-phone": "footer-module-scss-module__0M0JVW__support-phone",
  "support-phone-icon": "footer-module-scss-module__0M0JVW__support-phone-icon",
  "support-phone-text": "footer-module-scss-module__0M0JVW__support-phone-text",
  "support-title": "footer-module-scss-module__0M0JVW__support-title",
  "text": "footer-module-scss-module__0M0JVW__text",
});
